import React from "react";
import TextField from "@mui/material/TextField";
import type { TextFieldProps } from "@mui/material/TextField";
import ValidatorComponent from "../core/validator/ValidatorComponent";

type MuiTextFieldProps = Omit<TextFieldProps, "value"> & {
  value: unknown;
  validators?: any[];
  errorMessages?: string | string[];
  validatorListener?: (isValid: boolean) => void;
  withRequiredValidator?: boolean;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
};

export default class MuiTextField extends ValidatorComponent<MuiTextFieldProps> {
  renderValidatorComponent() {
    const {
      error,
      errorMessages,
      validators,
      helperText,
      validatorListener,
      withRequiredValidator,
      containerProps,
      ...rest
    } = this.props;

    const { isValid } = this.state;

    const hasError = !isValid || Boolean(error);

    return (
      <TextField
        {...rest}
        error={hasError}
        helperText={!isValid ? this.getErrorMessage() : helperText}
      />
    );
  }
}